/**
 * Shared AI model type definitions.
 */

export type ModelProvider = 'openai' | 'anthropic' | 'google' | 'meta' | 'xai' | 'mistral' | 'custom';

export type ModelCapability = 'reasoning' | 'long-context' | 'speed';

export type ModelTier = 'premium' | 'standard' | 'experimental';

export const MODEL_ROLES = {
  PREMIUM: 'reasoning-premium',
  STANDARD: 'reasoning-standard',
} as const;

export type ModelRole = (typeof MODEL_ROLES)[keyof typeof MODEL_ROLES];

export interface ModelDefinition {
  aliasKeys?: readonly string[];
  // User-facing aliases we still resolve to this canonical id (e.g. shorter provider model names)
  alternateIds?: readonly string[];
  capabilities?: readonly ModelCapability[];
  defaultConfig?: {
    maxTokens?: number;
    temperature?: number;
    providerOptions?: Record<string, unknown>;
  };
  defaultEnabled?: boolean;
  description: string;
  id: string;
  isDefault?: boolean;
  isFallback?: boolean;
  label: string;
  provider: ModelProvider;
  providerModelId?: string;
  role?: ModelRole;
  tier: ModelTier;
}
